import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    RemoveConflictCalendar as RemoveConflictCalendarMutation,
    RemoveConflictCalendarVariables as RemoveConflictCalendarVariables,
} from 'nutshell-graphql-types';

import REMOVE_CONFLICT_CALENDAR from '../mutations/remove-conflict-calendar.graphql';
import GET_CONFLICT_CALENDARS from '../queries/get-calendars.graphql';

export const useRemoveConflictCalendar = (): {
    removeConflictCalendar: (calendarId: string) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [removeConflictCalendar, {loading, error}] = useMutation<
        RemoveConflictCalendarMutation,
        RemoveConflictCalendarVariables
    >(REMOVE_CONFLICT_CALENDAR);

    return {
        removeConflictCalendar: (calendarId: string) =>
            removeConflictCalendar({
                variables: {calendarId},
                update: (proxy) => {
                    const cacheResult = proxy.readQuery({
                        query: GET_CONFLICT_CALENDARS,
                    });

                    const updatedCalendars =
                        cacheResult &&
                        // @ts-expect-error
                        cacheResult.calendars.filter((calendar) => calendar.id !== calendarId);

                    proxy.writeQuery({
                        query: GET_CONFLICT_CALENDARS,
                        data: {calendars: updatedCalendars},
                    });
                },
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
